export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

// Push générique
export const pushEvent = (event: string, params: Record<string, unknown> = {}) => {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}

const waitForConsent = (callback: () => void) => {
    const interval = setInterval(() => {
        const hasConsent = window.dataLayer.some(
            (entry: any) => entry['1'] === 'update' && entry['2']?.analytics_storage === 'granted'
        )
        if (hasConsent) {
            clearInterval(interval)
            callback()
        }
    }, 200)

    // Stop après 10 secondes
    setTimeout(() => clearInterval(interval), 10000)
}

export const pushEcommerceEvent = (event: string, ecommerce: Record<string, unknown>) => {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []

    const push = () => {
        window.dataLayer.push({ ecommerce: null })
        window.dataLayer.push({ event, ecommerce })
    }

    const hasConsent = window.dataLayer.some(
        (entry: any) => entry['1'] === 'update' && entry['2']?.analytics_storage === 'granted'
    )

    if (hasConsent) {
        push()
    } else {
        waitForConsent(push)
    }
}